export enum LayoutSize {
  Container = 720,
}
